import { createAction } from '@reduxjs/toolkit';
const prefix = 'elevio/suggestions';
export const suggestionActions = {
    setInitialConversationSuggestionState: createAction(`${prefix}/setInitialConversationSuggestionState`),
    fetchTokenStart: createAction(`${prefix}/fetchTokenStart`),
    fetchTokenSuccess: createAction(`${prefix}/fetchTokenSuccess`),
    fetchTokenError: createAction(`${prefix}/fetchTokenError`),
    subscriptionStatusSuccess: createAction(`${prefix}/subscriptionStatusSuccess`),
    subscriptionStatusError: createAction(`${prefix}/subscriptionStatusError`),
    setCompanyUid: createAction(`${prefix}/setCompanyUid`),
    clearTokenAndCompanyUid: createAction(`${prefix}/clearTokenAndCompanyUid`),
    setSearchInputValue: createAction(`${prefix}/setSearchInputValue`),
    setSearchTerm: createAction(`${prefix}/setSearchTerm`),
    viewArticle: createAction(`${prefix}/viewArticle`),
    articleNavBack: createAction(`${prefix}/articleNavBack`),
    // language settings
    fetchAvailableLanguagesRequest: createAction(`${prefix}/fetchAvailableLanguagesRequest`),
    fetchAvailableLanguagesComplete: createAction(`${prefix}/fetchAvailableLanguagesComplete`),
    fetchAvailableLanguagesFailure: createAction(`${prefix}/fetchAvailableLanguagesFailure`),
    setDetectedLanguageId: createAction(`${prefix}/setDetectedDefaultLanguageId`),
    // Fetching suggestions
    fetchSuggestionsRequest: createAction(`${prefix}/fetchSuggestionsRequest`),
    fetchSuggestionsRequestWithoutTags: createAction(`${prefix}/fetchSuggestionsRequestWithoutTags`),
    fetchSuggestionsComplete: createAction(`${prefix}/fetchSuggestionsComplete`),
    fetchSuggestionsFailure: createAction(`${prefix}/fetchSuggestionsFailure`),
    setUnableToFindTaggedSuggestions: createAction(`${prefix}/setUnableToFindTaggedSuggestions`),
};
